const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 5000,
        },
        loop: true,
        mode: 'snap',
        disabled: true,
        slides: {
          origin: 'center',
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: false,
            slides: {
              origin: 'center',
              perView: 1.8,
              spacing: 0,
            },
          },
        },
        detailsChanged: (instance) => {
          const slideEls = this.querySelectorAll(
            '[data-cta-carousel-el="slide"]',
          )

          slideEls.forEach((slideEl, index) => {
            const matchingSlide = instance.track.details.slides[index]

            const slidePortion = matchingSlide.portion

            const rotatePosNeg = matchingSlide.distance < 0 ? '-' : ''

            const rotateLimit = 15
            const rotateAmount = rotateLimit - rotateLimit * slidePortion

            const translateYLimit = 20
            const translateYAmount =
              translateYLimit - translateYLimit * slidePortion

            const mediaScaleLimit = 0.3
            const mediaScaleAmount =
              1 - (mediaScaleLimit - mediaScaleLimit * slidePortion)

            slideEl.style.setProperty(
              '--Slide_Transform',
              `rotate(${rotatePosNeg}${rotateAmount}deg) translateY(${translateYAmount}%)`,
            )
            slideEl.style.setProperty(
              '--Media_Transform',
              `scale(${mediaScaleAmount})`,
            )

            slideEl.classList.toggle(
              'sec-CtaCarousel_Slide-active',
              instance.track.details.abs === matchingSlide.abs,
            )
          })
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
